import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/apoio/usp.png")